module.exports = __webpack_public_path__ + "img/27.b974eeaf.svg";